export const clearJournalIfExpired = () => {
  const today = new Date().toISOString().split("T")[0];
  const lastUpdated = localStorage.getItem("journalLastUpdatedDate");

  if (lastUpdated && lastUpdated !== today) {
    const existing = JSON.parse(localStorage.getItem("journalData") || "[]");
    const filtered = existing.filter(log => log.day === today);
    localStorage.setItem("journalData", JSON.stringify(filtered));
    localStorage.setItem("journalLastUpdatedDate", today);
  }
};
